export function getJWT() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) return null;
  
  const userToken = JSON.parse(tokenString);
  return userToken?.token || null;
}

export function isAdmin() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) return false;
  
  const userToken = JSON.parse(tokenString);
  const token = userToken?.token;
  
  if (token && token.startsWith('eyJ')) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      const decoded = JSON.parse(jsonPayload);
      
      // Check if token is expired
      if (decoded.exp * 1000 < Date.now()) {
        console.log("Token expired, clearing localStorage");
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        return false;
      }
      
      return decoded.isAdmin === true;
    } catch (e) {
      console.error("JWT decode error:", e);
      return false;
    }
  }
  
  return false;
}

export function getJWTWithFallback() {
  const jwt = getJWT();
  if (jwt) return jwt;
  
  return null;
}

export function isTokenExpired() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) return true;
  
  const userToken = JSON.parse(tokenString);
  const token = userToken?.token;
  
  if (!token) return true;
  
  if (!token.startsWith('eyJ')) return true;
  
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const decoded = JSON.parse(jsonPayload);
    
    if (!decoded.exp) return false;
    
    return decoded.exp * 1000 < Date.now();
  } catch (e) {
    return true;
  }
}
